module.exports = __webpack_public_path__ + "img/entrance_plant_5.ccf6d9df.jpg";